import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/combining',
  component: Layout,
  redirect: '/combining/index',
  name: 'Combining',
  meta: {
    title: '合辑管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'CombiningIndex',
      component: () => import('@/views/combining/index.vue'),
      meta: {
        title: '合辑管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/combining"
      },
    }
  ],
}

export default routes
